var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-form",
    {
      ref: "baseForm",
      staticClass: "el-form-flex",
      attrs: {
        disabled: !_vm.canEdit,
        model: _vm.storeInfo,
        rules: _vm.rules,
        "label-width": "120px",
      },
    },
    [
      _vm.storeInfo && _vm.storeInfo.detail
        ? _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { sm: 24, md: 12, lg: 10 } }, [
                _c(
                  "div",
                  { staticClass: "el-form-content" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "经营类型", prop: "workingGroup" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "max-width",
                            on: { change: _vm.onChange },
                            model: {
                              value: _vm.storeInfo.detail.workingGroup,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.storeInfo.detail,
                                  "workingGroup",
                                  $$v
                                )
                              },
                              expression: "storeInfo.detail.workingGroup",
                            },
                          },
                          [
                            _c("el-option", {
                              attrs: { value: 12, label: "普通商户" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商户类型", prop: "merchantType" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "max-width",
                            attrs: { size: "small" },
                            on: { input: _vm.onChange },
                            model: {
                              value: _vm.storeInfo.detail.merchantType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.storeInfo.detail,
                                  "merchantType",
                                  $$v
                                )
                              },
                              expression: "storeInfo.detail.merchantType",
                            },
                          },
                          [
                            _c("el-radio-button", { attrs: { label: 1 } }, [
                              _vm._v("企业商户"),
                            ]),
                            _c("el-radio-button", { attrs: { label: 2 } }, [
                              _vm._v("个体工商户"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "推荐人邀请码", prop: "inviteCode" } },
                      [
                        _c("el-input", {
                          staticClass: "max-width",
                          attrs: { placeholder: "请输入推荐人邀请码" },
                          on: { blur: _vm.onChange },
                          model: {
                            value: _vm.storeInfo.inviteCode,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.storeInfo,
                                "inviteCode",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "storeInfo.inviteCode",
                          },
                        }),
                        _vm.storeInfo.inviterName
                          ? _c("span", { staticClass: "pl-10" }, [
                              _vm._v(_vm._s(_vm.storeInfo.inviterName)),
                            ])
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商户全称", prop: "shopName" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入营业执照上的全称" },
                          on: { blur: _vm.onChange },
                          model: {
                            value: _vm.storeInfo.shopName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.storeInfo,
                                "shopName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "storeInfo.shopName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "商户简称", prop: "shortName" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "将在支付完成页面向消费者展示",
                          },
                          on: { blur: _vm.onChange },
                          model: {
                            value: _vm.storeInfo.shortName,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.storeInfo,
                                "shortName",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "storeInfo.shortName",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      {
                        attrs: {
                          label: "营业执照编号",
                          prop: "detail.licenceNo",
                        },
                      },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入统一社会信用代码" },
                          on: { blur: _vm.onChange },
                          model: {
                            value: _vm.storeInfo.detail.licenceNo,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.storeInfo.detail,
                                "licenceNo",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "storeInfo.detail.licenceNo",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "执照有效期类型" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            staticClass: "max-width",
                            on: { input: _vm.onChange },
                            model: {
                              value: _vm.storeInfo.detail.licenseDateType,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.storeInfo.detail,
                                  "licenseDateType",
                                  $$v
                                )
                              },
                              expression: "storeInfo.detail.licenseDateType",
                            },
                          },
                          [
                            _c("el-radio-button", { attrs: { label: 1 } }, [
                              _vm._v("非长期"),
                            ]),
                            _c("el-radio-button", { attrs: { label: 2 } }, [
                              _vm._v("长期"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.storeInfo.detail.licenseDateType === 1
                      ? _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "营业执照有效期",
                              prop: "detail.licenseDate",
                            },
                          },
                          [
                            _c("el-date-picker", {
                              key: "licenseDateType1",
                              attrs: {
                                type: "daterange",
                                "range-separator": "至",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                format: "yyyy-MM-dd",
                                "value-format": "yyyy-MM-dd",
                              },
                              on: { blur: _vm.onChange },
                              model: {
                                value: _vm.storeInfo.detail.licenseDate,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.storeInfo.detail,
                                    "licenseDate",
                                    $$v
                                  )
                                },
                                expression: "storeInfo.detail.licenseDate",
                              },
                            }),
                          ],
                          1
                        )
                      : _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: "营业执照有效期",
                              prop: "detail.licenseStart",
                            },
                          },
                          [
                            _c("el-date-picker", {
                              key: "licenseDateType2",
                              staticClass: "max-width",
                              attrs: {
                                type: "date",
                                placeholder: "开始日期",
                                format: "yyyy-MM-dd",
                                "value-format": "yyyy-MM-dd",
                              },
                              on: { blur: _vm.onChange },
                              model: {
                                value: _vm.storeInfo.detail.licenseStart,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.storeInfo.detail,
                                    "licenseStart",
                                    $$v
                                  )
                                },
                                expression: "storeInfo.detail.licenseStart",
                              },
                            }),
                          ],
                          1
                        ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "所在区域", prop: "regionInfo" } },
                      [
                        _vm.showRegion
                          ? _c("el-cascader", {
                              ref: "regionCascader",
                              staticStyle: { width: "100%" },
                              attrs: {
                                props: {
                                  value: "regionCode",
                                  label: "regionName",
                                },
                                options: _vm.regionOptions,
                                placeholder: "请选择所在区域",
                                clearable: "",
                              },
                              on: { change: _vm.regionChange },
                              model: {
                                value: _vm.storeInfo.regionInfo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.storeInfo, "regionInfo", $$v)
                                },
                                expression: "storeInfo.regionInfo",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "详细地址", prop: "address" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入详细地址" },
                          on: { blur: _vm.onChange },
                          model: {
                            value: _vm.storeInfo.address,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.storeInfo,
                                "address",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "storeInfo.address",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "积分抵扣", prop: "discount" } },
                      [
                        _c(
                          "el-input",
                          {
                            staticClass: "max-width",
                            attrs: {
                              type: "number",
                              min: "0",
                              max: "30",
                              placeholder: "请输入优惠折扣",
                            },
                            on: { blur: _vm.onChange },
                            model: {
                              value: _vm.storeInfo.discount,
                              callback: function ($$v) {
                                _vm.$set(_vm.storeInfo, "discount", $$v)
                              },
                              expression: "storeInfo.discount",
                            },
                          },
                          [
                            _c(
                              "span",
                              { attrs: { slot: "suffix" }, slot: "suffix" },
                              [_vm._v("%")]
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
              _c(
                "el-col",
                { attrs: { sm: 24, md: 12, lg: { span: 10, offset: 4 } } },
                [
                  _c(
                    "div",
                    { staticClass: "el-form-content" },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "登录手机号", prop: "mobile" } },
                        [
                          _c("el-input", {
                            staticClass: "max-width",
                            attrs: {
                              type: "number",
                              maxlength: 11,
                              placeholder: "请输入11位手机号码",
                            },
                            on: { blur: _vm.onChange },
                            model: {
                              value: _vm.storeInfo.mobile,
                              callback: function ($$v) {
                                _vm.$set(_vm.storeInfo, "mobile", $$v)
                              },
                              expression: "storeInfo.mobile",
                            },
                          }),
                        ],
                        1
                      ),
                      !_vm.disabled
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "登录密码", prop: "password" } },
                            [
                              _c("el-input", {
                                staticClass: "max-width",
                                attrs: {
                                  "show-password": "",
                                  placeholder: "请输入登录密码",
                                },
                                on: { blur: _vm.onChange },
                                model: {
                                  value: _vm.storeInfo.password,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.storeInfo, "password", $$v)
                                  },
                                  expression: "storeInfo.password",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.disabled
                        ? _c(
                            "el-form-item",
                            { attrs: { label: "平台商户编号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: "",
                                  placeholder: "平台商户编号",
                                },
                                on: { blur: _vm.onChange },
                                model: {
                                  value: _vm.storeInfo.merchantId,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.storeInfo, "merchantId", $$v)
                                  },
                                  expression: "storeInfo.merchantId",
                                },
                              }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "法人姓名",
                            prop: "detail.legalName",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入法人姓名" },
                            on: { blur: _vm.onChange },
                            model: {
                              value: _vm.storeInfo.detail.legalName,
                              callback: function ($$v) {
                                _vm.$set(_vm.storeInfo.detail, "legalName", $$v)
                              },
                              expression: "storeInfo.detail.legalName",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "法人身份证号码",
                            prop: "detail.legalIdCard",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入法人身份证号码" },
                            on: { blur: _vm.onChange },
                            model: {
                              value: _vm.storeInfo.detail.legalIdCard,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.storeInfo.detail,
                                  "legalIdCard",
                                  $$v
                                )
                              },
                              expression: "storeInfo.detail.legalIdCard",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "证件有效期类型" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              staticClass: "max-width",
                              on: { input: _vm.onChange },
                              model: {
                                value: _vm.storeInfo.detail.cardDateType,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.storeInfo.detail,
                                    "cardDateType",
                                    $$v
                                  )
                                },
                                expression: "storeInfo.detail.cardDateType",
                              },
                            },
                            [
                              _c("el-radio-button", { attrs: { label: 1 } }, [
                                _vm._v("非长期"),
                              ]),
                              _c("el-radio-button", { attrs: { label: 2 } }, [
                                _vm._v("长期"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.storeInfo.detail.cardDateType === 1
                        ? _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "法人证件有效期",
                                prop: "detail.cardDate",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                key: "cardDateType1",
                                attrs: {
                                  type: "daterange",
                                  "range-separator": "至",
                                  "start-placeholder": "开始日期",
                                  "end-placeholder": "结束日期",
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd",
                                },
                                on: { blur: _vm.onChange },
                                model: {
                                  value: _vm.storeInfo.detail.cardDate,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.storeInfo.detail,
                                      "cardDate",
                                      $$v
                                    )
                                  },
                                  expression: "storeInfo.detail.cardDate",
                                },
                              }),
                            ],
                            1
                          )
                        : _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "法人证件有效期",
                                prop: "detail.legalCardStart",
                              },
                            },
                            [
                              _c("el-date-picker", {
                                key: "cardDateType2",
                                staticClass: "max-width",
                                attrs: {
                                  type: "date",
                                  placeholder: "开始日期",
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd",
                                },
                                on: { blur: _vm.onChange },
                                model: {
                                  value: _vm.storeInfo.detail.legalCardStart,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.storeInfo.detail,
                                      "legalCardStart",
                                      $$v
                                    )
                                  },
                                  expression: "storeInfo.detail.legalCardStart",
                                },
                              }),
                            ],
                            1
                          ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "营业时间", prop: "openHours" } },
                        [
                          _c("el-time-picker", {
                            staticClass: "max-width",
                            attrs: {
                              format: "HH:mm",
                              "value-format": "HH:mm",
                              editable: false,
                              placeholder: "开始时间",
                            },
                            on: { blur: _vm.onChange },
                            model: {
                              value: _vm.storeInfo.openHours[0],
                              callback: function ($$v) {
                                _vm.$set(_vm.storeInfo.openHours, 0, $$v)
                              },
                              expression: "storeInfo.openHours[0]",
                            },
                          }),
                          _c("span", { staticClass: "ml-10 mr-10" }, [
                            _vm._v("至"),
                          ]),
                          _c("el-time-picker", {
                            staticClass: "max-width",
                            attrs: {
                              format: "HH:mm",
                              "value-format": "HH:mm",
                              editable: false,
                              placeholder: "打烊时间",
                            },
                            on: { blur: _vm.onChange },
                            model: {
                              value: _vm.storeInfo.openHours[1],
                              callback: function ($$v) {
                                _vm.$set(_vm.storeInfo.openHours, 1, $$v)
                              },
                              expression: "storeInfo.openHours[1]",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "门店电话", prop: "phone" } },
                        [
                          _c("el-input", {
                            staticClass: "max-width",
                            attrs: {
                              type: "number",
                              placeholder: "请输入门店电话",
                            },
                            on: { blur: _vm.onChange },
                            model: {
                              value: _vm.storeInfo.phone,
                              callback: function ($$v) {
                                _vm.$set(_vm.storeInfo, "phone", $$v)
                              },
                              expression: "storeInfo.phone",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "特色介绍", prop: "feature" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入特色介绍" },
                            on: { blur: _vm.onChange },
                            model: {
                              value: _vm.storeInfo.feature,
                              callback: function ($$v) {
                                _vm.$set(_vm.storeInfo, "feature", $$v)
                              },
                              expression: "storeInfo.feature",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: "资质编号",
                            prop: "detail.qualification",
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder:
                                "请输入资质编号，如：粤卫食证字[2007]第0307A123456",
                            },
                            on: { blur: _vm.onChange },
                            model: {
                              value: _vm.storeInfo.detail.qualification,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.storeInfo.detail,
                                  "qualification",
                                  typeof $$v === "string" ? $$v.trim() : $$v
                                )
                              },
                              expression: "storeInfo.detail.qualification",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "排序", prop: "sortBy" } },
                        [
                          _c("el-input", {
                            staticClass: "max-width",
                            attrs: {
                              type: "number",
                              min: "0",
                              placeholder: "请输入排列顺序",
                            },
                            on: { blur: _vm.onChange },
                            model: {
                              value: _vm.storeInfo.sortBy,
                              callback: function ($$v) {
                                _vm.$set(_vm.storeInfo, "sortBy", $$v)
                              },
                              expression: "storeInfo.sortBy",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }